<template>
  <div>
    <Header />
    <div class="statusDetail">
      <h2><i class="fas fa-clipboard-list"></i> 訂單詳情</h2>

      <!-- <div class="productCard" v-for="(item, index) in CartData" :key="index">
          <div class="left">
            <img
              :src="APIURL + 'images/items/' + item.product_image"
              alt=""
            /><br />
            <div class="content">
              <h2>{{ item.product_names }}</h2>
              <h3>x{{ item.count }}{{ item.product_unit }}</h3>
            </div>
          </div>
          <p class="right">${{ item.product_sellPrice * item.count }}</p>
          <template
            v-if="item.isPackage && item.products && item.products.length !== 0"
          >
            <div
              class="add"
              v-for="prod in item.products"
              :key="prod.product_id"
            >
              <img
                :src="APIURL + 'images/items/' + prod.productImg"
                alt=""
              /><br />
              <div class="content">
                <h2>{{ prod.names }}</h2>
                <h3>總共 {{ prod.amount * item.count }} {{ prod.unit }}</h3>
              </div>
            </div>
          </template>
        </div> -->

      <div
        class="product"
        v-for="item in packages"
        :key="item.detail.productId"
      >
        <div class="right">
          <img
            :src="APIURL + 'images/items/' + item.package.packageImg"
            alt=""
          />
          <h3>{{ item.package.packageName }}</h3>
        </div>
        <div class="product_intro">
          <h4>x{{ item.package.packageAmount }} {{item.package.unit}}</h4>
          <h5>${{ item.package.packageAmount * item.package.packagePrice }}</h5>
        </div>
        <div class="add" v-for="prod in item.detail" :key="prod.productId">
          <img :src="APIURL + 'images/items/' + prod.productImg" alt="" /><br />
          <div class="content">
            <h2>{{ prod.productName }}</h2>
            <h3>總共 {{ prod.amount }} {{ prod.unit }}</h3>
          </div>
        </div>
      </div>

      <div class="product" v-for="item in product" :key="item.detail.productId">
        <div class="right">
          <img
            :src="APIURL + 'images/items/' + item.detail.productImg"
            alt=""
          />
          <h3>{{ item.detail.productName }}</h3>
        </div>
        <div class="product_intro">
          <h4>x{{ item.detail.amount }} {{ item.detail.unit }}</h4>
          <h5>${{ item.detail.totalPrice }}</h5>
        </div>
      </div>

      <div class="price">
        <h4>商品小計</h4>
        <h5>${{ info.price }}</h5>
      </div>
      <div class="price">
        <h4>運費</h4>
        <h5>${{ info.shipPrice }}</h5>
      </div>
      <div class="total">
        <h4>訂單金額</h4>
        <h5>${{ parseInt(info.price, 10) + parseInt(info.shipPrice, 10) }}</h5>
      </div>

      <h2><i class="fas fa-truck"></i> 付款與收貨方式</h2>
      <h3>
        <span>{{ info.pay_name }}</span
        ><br />{{ info.address }}
      </h3>

      <h2><i class="fas fa-clock"></i> 訂單資訊</h2>
      <div class="ordertime">
        <h4>下單時間</h4>
        <h5>{{ info.orderTime }}</h5>
      </div>
      <!-- <div class="ordertime">
        <h4>處理時間</h4>
        <h5>{{info.shippingTime}}</h5>
      </div> -->
      <div class="ordertime" v-if="info.shippingTime !== '0'">
        <h4>出貨時間</h4>
        <h5>{{ info.shippingTime }}</h5>
      </div>
      <div class="ordertime" v-if="info.finishTime !== '0'">
        <h4>完成時間</h4>
        <h5>{{ info.finishTime }}</h5>
      </div>
      <div class="ordertime" v-if="info.comment!==''">
        <h4>備註:</h4>
        <h5 >{{ info.comment }}</h5>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header.vue';
import $ from 'jquery';

export default {
  components: {
    Header,
  },
  data() {
    return {
      user_name: '',
      user_avator: '',
      user_id: '',
      APIURL: process.env.VUE_APP_APIURL,

      info: {},
      packages: [],
      product: [],
    };
  },
  async created() {
    // const vm = this;
    await this.LineLoginValidate();
    console.log(this.$route.params.orderid);
    // if (this.$route.params.orderid && vm.user_id) {
    //   await $.ajax({
    //     url: `${process.env.VUE_APP_APIURL}front/cart/show_order_detail`,
    //     type: 'POST',
    //     data: {
    //       userId: vm.user_id,
    //       orderId: vm.$route.params.orderid,
    //     },
    //     success(res) {
    //       const data = JSON.parse(res);
    //       console.log('訂單詳情', data);
    //     // vm.orders = data.result;
    //     },
    //   });
    // }
    // await $.ajax({
    //   url: `${process.env.VUE_APP_APIURL}front/cart/show_order_detail`,
    //   type: 'POST',
    //   data: {
    //     userId: vm.user_id,
    //     orderId: vm.$route.params.orderid,
    //   },
    //   success(res) {
    //     const data = JSON.parse(res);
    //     console.log('訂單列表', data);
    //     // vm.orders = data.result;
    //     // console.log('info', data.info[0]);
    //     const info = data.info[0];
    //     vm.info = info;
    //     vm.packages = data.package;
    //     vm.product = data.product;
    //   },
    // });
  },
  methods: {
    LineLoginValidate() {
      const vm = this;
      if (this.$cookies.get('access_token')) {
        // alert('有登入過');
        // 驗證如果登入過
        $.ajax({
          url: 'https://api.line.me/v2/profile',
          type: 'GET',
          headers: {
            Authorization: `Bearer ${vm.$cookies.get('access_token')}`,
          },
          success(user) {
            console.log(user);
            if (user.displayName && user.pictureUrl && user.userId) {
              vm.user_name = user.displayName;
              vm.user_avator = user.pictureUrl;
              // vm.user_id = user.userId;
              // 取得資料後傳至後端
              $.ajax({
                url: `${process.env.VUE_APP_APIURL}front/account/line_login`,
                type: 'POST',
                data: {
                  user_name: user.displayName,
                  user_id: user.userId,
                },
                success(ok) {
                  console.log(ok);
                  const oks = JSON.parse(ok);
                  vm.user_id = oks.clientId;
                  vm.getOrderDetail(); // 取得所有訂單
                },
              });
            } else {
              vm.$cookies.remove('access_token');
              const clientId = process.env.VUE_APP_LINECLIENTID;
              const redirectUri = `${process.env.VUE_APP_URL}status`;
              let link = 'https://access.line.me/oauth2/v2.1/authorize?';
              link += 'response_type=code';
              link += `&client_id=${clientId}`;
              link += `&redirect_uri=${redirectUri}`;
              link += '&state=login';
              link += '&scope=profile%20openid%20email';
              window.location.href = link;
            }
          },
        });
      } else if (this.$route.query.code) {
        // alert('有code');
        // 取得code query
        // console.log(vm.$route.query.code, process.env.VUE_APP_URL);
        $.ajax({
          url: 'https://api.line.me/oauth2/v2.1/token',
          type: 'POST',
          contentType: 'application/x-www-form-urlencoded',
          data: {
            grant_type: 'authorization_code',
            client_id: process.env.VUE_APP_LINECLIENTID,
            client_secret: process.env.VUE_APP_LINESC,
            code: vm.$route.query.code,
            redirect_uri: `${process.env.VUE_APP_URL}status`,
          },
          success(res) {
            console.log(res);
            if (res.access_token) {
              vm.$cookies.set('access_token', res.access_token, 60 * 60 * 24 * 20);
              $.ajax({
                url: 'https://api.line.me/v2/profile',
                type: 'GET',
                headers: {
                  Authorization: `Bearer ${res.access_token}`,
                },
                success(user) {
                  console.log('user', user);
                  vm.user_name = user.displayName;
                  vm.user_avator = user.pictureUrl;
                  // vm.user_id = user.userId;
                  // 取得資料後傳至後端
                  $.ajax({
                    url: `${process.env.VUE_APP_APIURL}front/account/line_login`,
                    type: 'POST',
                    data: {
                      user_name: user.displayName,
                      user_id: user.userId,
                    },
                    success(ok) {
                      console.log(ok);
                      const oks = JSON.parse(ok);
                      vm.user_id = oks.clientId;
                      vm.$router.push('/status');
                      vm.getOrderDetail(); // 取得所有訂單
                    },
                  });
                },
              });
            }
          },
        });
      } else {
        // alert('沒code');
        const clientId = process.env.VUE_APP_LINECLIENTID;
        const redirectUri = `${process.env.VUE_APP_URL}status`;
        let link = 'https://access.line.me/oauth2/v2.1/authorize?';
        link += 'response_type=code';
        link += `&client_id=${clientId}`;
        link += `&redirect_uri=${redirectUri}`;
        link += '&state=login';
        link += '&scope=profile%20openid%20email';
        window.location.href = link;
      }
      // console.log('this.$route.query.code', this.$route.query.code);
    },
    getOrderDetail() {
      console.log('撈詳情');
      const vm = this;

      vm.$store.commit('setLoading', true);
      $.ajax({
        url: `${process.env.VUE_APP_APIURL}front/cart/show_order_detail`,
        type: 'POST',
        data: {
          userId: vm.user_id,
          orderId: vm.$route.params.orderid,
        },
        success(res) {
          vm.$store.commit('setLoading', false);
          const data = JSON.parse(res);
          console.log('詳情', data);
          const info = data.info[0];
          vm.info = info;
          vm.packages = data.package;
          vm.product = data.product;
        },
      });
    },
  },
};
</script>

<style>
</style>
